import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import Upgrade from 'modules/core/components/Upgrade'
import { UpgradeActions } from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import useCreateUpsellRequest, { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { useCreateUpsellNotificationMessage } from '../hooks/useCreateUpsellNotificationMessage'

interface UpsellWizardGenericStepProps {
  featureRequested: Features
  requestSource: string
}

export const UpsellWizardGenericStep = ({
  featureRequested,
  requestSource,
}: UpsellWizardGenericStepProps) => {
  const { company } = useCurrentSession()
  const currentSubscriptionPlan = company.subscription.plan
  const isLegacy = company.subscription.isPre2022Legacy
  const { sendUpsellNotificationMessage } = useCreateUpsellNotificationMessage()

  const [upsellRequested, setUpsellRequested] = React.useState(false)

  const { create } = useCreateUpsellRequest()

  const handleUpsell = () => {
    sendUpsellNotificationMessage(requestSource)

    create({
      moduleRequested: AvailableModules.projects,
      requestReason: isLegacy ? ValidReasons.MissingFeatureLegacy : ValidReasons.MissingFeature,
      featureRequested,
      requestSource,
    })

    setUpsellRequested(true)
  }

  return !upsellRequested ? (
    <Box flexDirection="column" gap="s24" width="s400">
      <Upgrade.Large
        currentPlanName={currentSubscriptionPlan}
        action={{
          type: UpgradeActions.contactCX,
          onClick: handleUpsell,
        }}
      />
    </Box>
  ) : (
    <Box flexDirection="column" gap="s48" width="s400">
      <Box
        padding="s24"
        gap="s24"
        justifyContent="flexStart"
        alignItems="flexStart"
        textAlign="left"
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        background="grey000White"
      >
        <Box gap="s16">
          <Box gap="s4">
            <Box alignItems="center" flexDirection="row" gap="s4">
              <Box flexNoShrink>
                <Icon.Medium icon="check-circle" color="apple1000" />
              </Box>
              <Text.Normal color="grey1000" weight="medium">
                {i18n.t('packaging.upgrade_modal.success_title')}
              </Text.Normal>
            </Box>
            <Text.Normal>{i18n.t('packaging.upgrade_modal.success_description')}</Text.Normal>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
